import api from '@/api/fetchClient'

export default {
  getAccounts(params = {}) {
    let url = 'cashbank/accounts'
    const queryParams = []

    if (params.search) {
      queryParams.push(`search=${encodeURIComponent(params.search)}`)
    }
    if (params.type) {
      queryParams.push(`type=${encodeURIComponent(params.type)}`)
    }

    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&')
    }

    return api.get(url, { authorized: true })
  },

  getAccountById(id) {
    return api.get(`cashbank/accounts/${id}`, { authorized: true })
  },

  createAccount(payload) {
    return api.post('cashbank/accounts', payload, { authorized: true })
  },

  updateAccount(id, payload) {
    return api.put(`cashbank/accounts/${id}`, payload, { authorized: true })
  },

  deleteAccount(id) {
    return api.delete(`cashbank/accounts/${id}`, { authorized: true })
  },

  getStats() {
    return api.get('cashbank/stats', { authorized: true })
  }
}
